import { all, call, put, takeLatest } from "redux-saga/effects";
import jwtDecode from "jwt-decode";
import moment from "moment";
import actions from "../actions";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get(action) {
    const { username, idToken } = action.payload;
    let accountUrl;

    // Identity tokens are only ever issued by Azure B2C through MSAL. There is
    // deliberately no password-based path here - MsalAuth handles silent renewal
    // and hands off to the B2C hosted login page when interaction is required.
    if (!idToken) {
        yield put(
            actionCreators.getFailure(
                "No identity token supplied. Please log in again."
            )
        );
        return;
    }

    try {
        const token = idToken;

        const { exp, sub } = jwtDecode(token);
        accountUrl = `${config.api.paths.me}?identity_id=${sub}&source=1`;

        const account = yield call(http.anonymous.get, accountUrl, {
            Authorization: `Bearer ${token}`
        });
        console.log(
            "✅ Account data received:",
            account?.data?.length || 0,
            "items"
        );

        // If backend returns empty array, token is invalid or user doesn't exist
        if (!account.data || account.data.length === 0) {
            yield put(actionCreators.getFailure(
                "No account found for this user. Please log in again."
            ));
            return;
        }

        const accountData = account.data[0];

        yield put(
            actionCreators.getSuccess({
                idToken: token,
                account: accountData,
                expiryDate: moment.unix(exp).utc(),
                identityId: sub,
                username: accountData.email || username,
                isAuthenticated: true
            })
        );
    } catch (error) {
        const errStr = error.toString();
        console.error("Auth saga error:", error);
        logToSentry("On auth get:", { error, errStr, accountUrl });
        yield put(actionCreators.getFailure(errStr));
    }
}

function* setPasswordPatch(action) {
    const { identityId, password } = action.payload;
    const url = `${config.api.authUrl}${config.api.paths.setPassword}`;
    try {
        const res = yield call(http.authorized.patch, url, {
            identityId,
            password
        });
        yield put(actionCreators.setPasswordPatchSuccess());
    } catch (error) {
        logToSentry("On auth set password patch:", { error });
        yield put(actionCreators.setPasswordPatchFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUTH_GET_REQUEST, get),
        takeLatest(
            actionTypes.AUTH_SET_PASSWORD_PATCH_REQUEST,
            setPasswordPatch
        )
    ]);
}
